
<template>
  <div class="biaodi">
    <!-- 筛选 -->

    <div
      class="bd_select"
      v-if="meeting == null"
    >

      <div class="o_sel o_sel_animation">
        <div class="tit f16">{{$t("subject.subject_type")}}</div>
        <!-- <el-select v-model="type" placeholder="请选择" class="sel_list">
					<el-option
						v-for="(item) in types"
						:key="item.value"
						:label="item.text"
						:value="item.value">
					</el-option>
				</el-select> -->
        <div class="sel_list" v-for="(item,index) in types" :key="index">

          <div class="tit f16">
            <router-link :to="{ path:'/biaodi',query:{ type:item.value,page:1 }}">{{item.value}}</router-link>
          </div>
        </div>
        <ul class="sel_list mobile">
          <li>
            <select v-model="type">
              <option
                v-for="(item,index) in types"
                :key="index"
                v-bind:value="item.value"
              >
                {{ item.text }}
              </option>
              <span>Selected: {{ type }}</span>
            </select>
          </li>
        </ul>
      </div>

      <!-- <div class="o_sel">
				<div class="tit f16">开拍时间:</div>
				<ul class="sel_list">
					<li>
						<select>
							<option value="全部">全部</option>
							<option value="近3天">近3天</option>
							<option value="近7天">近7天</option>
							<option value="近15天">近15天</option>
						</select>
					</li>
				</ul>
			</div> -->
    </div>
    <div
      class="bd_select"
      style="margin-top: 0;"
      v-if="meeting == null"
    >
      <div class="o_sel">
        <div class="tit f16">{{$t("subject.subject_address")}}</div>
        <ul class="sel_list">
          <li>
            <el-select
              v-model="province"
              placeholder="请选择"
            >
              <el-option
                v-for="(item) in provinces"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="city"
              placeholder="请选择"
            >
              <el-option
                v-for="(item) in citys"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </li>
        </ul>
        <ul class="sel_list mobile">
          <li>
            <select v-model="province">
              <option
                v-for="(item,index) in provinces"
                :key="index"
                v-bind:value="item.value"
              >
                {{ item.text }}
              </option>
              <span>Selected: {{ province }}</span>
            </select>
            <select v-model="city">
              <option
                v-for="(item,index) in citys"
                :key="index"
                v-bind:value="item.name"
              >
                {{ item.name }}
              </option>
              <span>Selected: {{ city }}</span>
            </select>
          </li>
        </ul>
      </div>
      <div class="o_sel">
        <div class="tit f16">{{$t("subject.subject_state")}}</div>
        <el-select
          v-model="status"
          placeholder="请选择"
          class="sel_list"
        >
          <el-option
            v-for="(item) in statusOptions"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <ul class="sel_list mobile">
          <li>
            <select v-model="status">
              <option
                v-for="(item,index) in statusOptions"
                :key="index"
                v-bind:value="item.value"
              >
                {{ item.text }}
              </option>
              <span>Selected: {{ status }}</span>
            </select>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="About"
      v-if="meeting != null"
    >
      <ul>
        <li>
          <router-link
            :to="{ path:'/biaodi',query:{ meeting_id:meeting.id,page:1,type:'全部' }}"
            class="List"
          >
            <!-- <div class="timer"><h1>{{ item.created_at }}</h1><p class="shengming">《拍界官方公告》</p></div> -->

            <div
              class="Img"
              :style="{'backgroundImage':'url('+meeting.img+')'}"
            >

            </div>

            <div class="Container">

              <h2>{{ meeting.title }}</h2>
              <p class="f16 meeting_text">拍卖企业：拍界官方</p>
              <p class="f16 meeting_text">开始时间：{{ meeting.start_at }}</p>

              <div>
                <router-link
                  class="f16 meeting-btn"
                  :to="{ path:'/biaodi',query:{ meeting_id:meeting.id,page:1,type:'全部' }}"
                >标的目录</router-link>
                <!-- 	<a target="_blank" class="f16 meeting-btn" href="/">标的目录</a> -->
              </div>

              <div class="People-lot">
                <p class="People-tab">围观次数：<span class="meetingcount">{{meeting.view_count*1+meeting.view_base_count*1}}</span>次</p>
                <p class="People-tab">标的数量：<span class="lotNum">{{meeting.subject_count}}</span>个</p>
              </div>

              <!-- <p class="go">...></p> -->
            </div>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- 列表 -->
    <div class="pp_list_temp">
      <ul>
        <li
          v-if="paginator.total_items == 0"
          class="kong_data"
        >{{$t("subject.no_data")}}</li>

        <li
          v-for="(item,index) in subjects"
          :key="index"
          v-else
        >
          <router-link :to="{path:'/biaodiDetails',query:{ id:item.id,meeting_id:meeting_id }}">
            <img
              class="push_img"
              src="@/assets/images/push.png"
              v-if="item.label == 'push'"
            >
            <img
              class="hot_img"
              src="@/assets/images/hot.png"
              v-if="item.label == 'hot'"
            >
            <img
              class="hot_img"
              src="@/assets/images/fire.png"
              v-if="item.label == 'fire'"
            >
            <img
              class="hot_img"
              src="@/assets/images/like.png"
              v-if="item.label == 'like'"
            >
            <img
              v-if="item.is_sold"
              class="chengjiao_img"
              src="../assets/images/chengjiao.png"
            >
            <div
              class="img_box"
              :style="{'backgroundImage':'url('+item.img+')'}"
              style="position: relative;"
            >
              <p class="watermark"><img src="@/assets/images/waterMark300.png"></p>
            </div>
            <div class="text_box">
              <p class="f16">{{ item.title }}</p>
              <div
                class="cj_price c_gray"
                v-show="status!=3"
              >
                <p>{{$t("subject.list.starting_price")}}</p>
                <p><span class="c_red f24">{{ (item.start_price) }}</span>元<span v-if="item.new_unit" class="new-unit">/{{item.new_unit}}</span></p>
              </div>
              <div
                class="cj_price c_gray"
                v-show="status==3"
              >
                <p>{{$t("subject.list.end_price")}}</p>
                <p><span class="c_red f24">{{ Math.trunc(item.price) }}</span>元<span v-if="item.new_unit" class="new-unit">/{{item.new_unit}}</span></p>
              </div>
              <div class="cj_price c_gray">
                <p>{{$t("subject.list.number")}}</p>
                <p>[{{ item.id }}]</p>
              </div>
              <div class="cj_price c_gray">
                <p>{{$t("subject.list.auction_time")}}</p>
                <p>{{ item.start_at }}</p>
              </div>
              <div class="cj_price c_gray">
                <p>{{$t("subject.list.subject_address")}}</p>
                <p>{{item.city}}</p>
              </div>
              <div class="cj_price c_gray see_person">
                <!-- <img src="@/assets/images/see1.png" alt="">{{Number(item.sign_count) + Number(item.sign_base_count)}}{{$t("subject.list.sign_up")}} |  -->
                <img
                  src="@/assets/images/see2.png"
                  alt=""
                >{{Number(item.view_count) + Number(item.view_base_count)}}{{$t("subject.list.onlookers")}}
              </div>
            </div>
            <!-- <div
              class="wkp"
              v-if="!item.is_sold"
            >{{item.biaodiState}}</div> -->
          </router-link>
        </li>
      </ul>
    </div>
    <div class="fenye">
      <ul>
        <li class="fenyehidden"><a v-on:click="setPage(paginator.first)">{{$t("subject.pagination.first")}}</a></li>
        <li v-if="paginator.current > 1"><a v-on:click="setPage(paginator.before)">{{$t("subject.pagination.prev")}}</a></li>
        <li
          v-if="paginator.current == 1"
          class="banclick fenyehidden"
        ><a>{{$t("subject.pagination.prev")}}</a></li>
        <!--当前页背景色为蓝色-->
        <li
          v-for="index in indexs"
          v-bind:class="{ 'active': paginator.current == index}"
          :key="index"
        >
          <a v-on:click="setPage(index)">{{ index }}</a>
        </li>
        <li v-if="paginator.current < paginator.total_items"><a v-on:click="setPage(paginator.next)">{{$t("subject.pagination.next")}}</a></li>
        <li
          v-if="paginator.current == paginator.total_items"
          class="banclick"
        ><a>{{$t("subject.pagination.next")}}</a></li>
        <li class="fenyehidden"><a v-on:click="setPage(paginator.last)">{{$t("subject.pagination.last")}}</a></li>
        <li class="fenyehidden"><a>{{$t("subject.pagination.all")}} {{ paginator.total_pages }} {{$t("subject.pagination.pages")}} {{ paginator.total_items }} {{$t("subject.pagination.record")}}</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
// var d = new Date(item.start_at);
// console.log(d+"aaaaaa");

// var d = new Date(item.start_at);
// var d = new Date('2020-07-04 10:00:00');
// console.log(d+"aaaaaa");
// var t = d.getTime(d)
//  console.log(t+"aaaaaaaaaaaa");
//  let t = d.valueOf(d)
// let t = d.parse(d)




const wx = require('weixin-js-sdk');


export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  data () {
    return {
      subjects: [],
      meeting: {},
      type: '全部',
      types: [],
      province: '全部',
      provinces: [],
      city: '全部',
      citys: [],
      status: '0',
      meeting_id: 0,
      statusOptions: [
        { text: '全部', value: '0' },
        { text: '即将开始', value: '1' },
        { text: '正在进行', value: '2' },
        // { text: '成交', value: '3' },
        { text: '已结束', value: '4' }
      ],
      //分页器
      paginator: {
        first: null,
        before: null,
        previous: null,
        current: 1,
        last: null,
        next: null,
        total_pages: null,
        total_items: null,
        limit: 8,
      },
    }
  },
  // 初始化函数
  created () {
    // 显示公共栏
    this.$emit('header', true);
    this.$emit('footer', true);

    // 加载分类和省份数据
    this.types = this.$global.subjectTypes;
    this.provinces = this.$global.provinces;

    // 加载路由参数
    this.getRouteQuery()

    // 请求列表数据
    this.getSubjects()

    


    // 微信分享
    const url = window.location.href.split('#')[0] //向服务端提供授权url参数，并且不需要#后面的部分
    this.axios.get(this.$global.apiUrl.wxuser_signature, {
      params: {
        url: url
      }
    })
      .then((response) => {

        if (response.data.error.code == 0) {
          wx.config({
            debug: false, // 开启调试模式,
            appId: response.data.signPackage.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: response.data.signPackage.timestamp, // 必填，生成签名的时间戳
            nonceStr: response.data.signPackage.nonceStr, // 必填，生成签名的随机串
            signature: response.data.signPackage.signature, // 必填，签名，见附录1
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
        }
      })
  },
  mounted () {
    // 微信分享
    wx.ready(() => {
      // 分享朋友
      wx.updateAppMessageShareData({
        title: '拍界',
        desc: '拍界经典新时代,拍卖无边界,拍卖更便捷',
        link: window.location.href,
        imgUrl: 'https://paijie.com/WechatIMG66.png',
        success: () => { }
      })
      // 分享朋友圈
      wx.updateTimelineShareData({
        title: '拍卖无边界,拍卖更便捷,拍界经典新时代',
        link: window.location.href,
        imgUrl: 'https://paijie.com/WechatIMG66.png',
        success: () => { }
      })
    })
  },
  // 方法属性
  methods: {

    // 获取路由参数
    getRouteQuery: function () {

      if (this.$route.query.type !== undefined) {
        this.type = this.$route.query.type;
      }

      if (this.$route.query.status !== undefined) {
        this.status = this.$route.query.status;
      }

      if (this.$route.query.page !== undefined) {
        this.paginator.current = this.$route.query.page;
      }

      if (this.$route.query.province !== undefined) {
        this.province = this.$route.query.province;
      }

      if (this.$route.query.city !== undefined) {
        this.city = this.$route.query.city;
      }

      if (this.$route.query.meeting_id !== undefined) {
        this.meeting_id = this.$route.query.meeting_id;
        
      }

    },

    // 获取城市列表
    getCitys (province) {
      this.citys = [];
      // this.city = "全部";
      if (province != "全部") {
        this.axios.get(this.$global.apiUrl.v3_config_district, {
          params: {
            key: '7f24d70f9de2b4e9e50bee4231a252d5',
            keywords: province,
            subdistrict: 1
          }
        })
          .then((response) => {

            this.citys = response.data.districts[0].districts;
            this.citys.splice(0, 0, { name: "全部" });

          })
      }
    },

    // 获取接口地址拼接参数
    getApi: function () {

      let api = this.$global.apiUrl.subjects;

      //let order = "end_at ASC";
      // let order = "id DESC";
      let order = "created_at DESC";

      api += "?page=" + this.paginator.current;

      api += "&limit=" + this.paginator.limit;

      
      if (this.$route.query.meeting_id !== undefined) {
        api += "&meeting_id=" + this.$route.query.meeting_id;
      }

      if (this.$route.query.searchVal !== undefined) {
        api += "&keyword=" + this.$route.query.searchVal;
      }
      // console.log(this.paginator.current)
      if (this.$route.query.type != "全部") {
        api += "&type=" + this.$route.query.type;
      }

      if (this.status != '0') {
        api += "&status=" + this.$route.query.status;
      }

      if (this.status == '1') {
        order = "start_at ASC";
      }

      if (this.status == '3') {
        order = "end_at DESC";

      }

      if (this.status == '4') {
        order = "end_at DESC";

      }

      if (this.province != '全部') {
        api += "&province=" + this.$route.query.province;
      }

      if (this.city != '全部') {
        api += "&city=" + this.$route.query.city;
      }

      api += "&order=" + order;
      
      return api;
    },

    // 计算标的状态
    computedStatus: function (subjects) {
      // console.log(0.1+0.2)
      let _this = this;
      subjects.forEach(function (value, index, array) {
        // console.log(subjects);
        // console.log(value);
        // console.log(index);
        // console.log(array);
        // 距离开始的时间
        var startTime = parseInt((new Date(value.start_at.replace(/\-/g, '/')).getTime() - new Date().getTime()));
        // 距离结束的时间
        var endTime = parseInt((new Date(value.end_at.replace(/\-/g, '/')).getTime() - new Date().getTime()));

        if (startTime > 0) {
          array[index]['biaodiState'] = _this.$t("subject.list.state.s_1")
        }
        if (startTime <= 0 & endTime > 0) {
          array[index]['biaodiState'] = _this.$t("subject.list.state.s_2")
        }
        if (startTime < 0 & endTime <= 0) {
          array[index]['biaodiState'] = _this.$t("subject.list.state.s_3")

        }


      });
      
      // console.log(subjects)
      return subjects;
    },

    // 请求本页列表数据
    getSubjects: function () {
      // console.log(this.getApi());
      this.axios.get(this.getApi())
        .then((response) => {

          if (response.data.error.code == 0) {
            // console.log(response);
            this.subjects = this.computedStatus(response.data.subjects);
            this.paginator = response.data.paginator;
            this.meeting = response.data.meeting;
          }
        })
    },

    setPage: function (page) {
      let query = Object.assign({}, this.$route.query, { page: page })
      this.$router.push({ query: query })
    },

    resetPage: function (query) {
      return Object.assign({}, query, { page: 1 })
    },

    setType: function (type) {

      let query = Object.assign({}, this.$route.query, { type: type })
      if (type != this.$route.query.type) {
        query = this.resetPage(query)
      }
      this.$router.push({ query: query })
    },

    setStatus: function (status) {

      let query = Object.assign({}, this.$route.query, { status: status })
      if (status != this.$route.query.status) {
        query = this.resetPage(query)
      }
      this.$router.push({ query: query })

    },

    setCity: function (city) {

      let query = Object.assign({}, this.$route.query, { city: city })
      if (city != this.$route.query.city) {
        query = this.resetPage(query)
      }
      this.$router.push({ query: query })

    },

    setProvince: function (province) {

      let query = Object.assign({}, this.$route.query, { province: province })
      if (province != this.$route.query.province) {
        query = this.resetPage(query)
      }
      this.$router.push({ query: query })

    },
  },
  // 监听器
  watch: {

    $route () {
      this.paginator.current = this.$route.query.page;
      this.getSubjects();
    },

    // 标的区域省份筛选
    province (val, oldVal) {
      this.setProvince(val);
      this.getCitys(val);
      if (oldVal != '全部') {
        this.city = "全部";
      }
    },

    // 标的区域城市筛选
    city (val) {
      this.setCity(val)
    },

    // 标的类型筛选
    type (val) {
      this.setType(val)
    },

    // 标的状态筛选
    status (val) {
      // console.log(val+"aaaaaaa")
      this.setStatus(val)
    },

  },
  // 计算属性
  computed: {

    // 分页
    indexs: function () {
      var left = 1;
      var right = this.paginator.total_pages;
      var ar = [];
      if (this.paginator.total_pages >= 5) {
        //这里最大范围从3到6，如果到达7，那么下边加2变成9，已经超过最大的范围值
        if (this.paginator.current > 3 && this.paginator.current < this.paginator.total_pages - 1) {
          //以4为参考基准，左面加2右边加2
          left = this.paginator.current - 2
          right = this.paginator.current + 2
        } else {
          if (this.paginator.current <= 3) {
            left = 1
            right = 5
          } else {
            right = this.paginator.total_pages
            left = this.paginator.total_pages - 4
          }
        }
      }
      while (left <= right) {
        ar.push(left)
        left++
      }
      return ar
    }
  }
}
</script>
<style scoped>
.new-unit {
  font-size:12px;
  color:#888;
}
</style>